import { formatServerDate, moscowShortDate, moscowTime, parseServerDate, startOfMoscowDay } from './moscowTime';
import { normalizePlate } from './plate';

/**
 * «Пропуск бригаде» (ideas 2026-10-13, №3 «Подрядчики и стройка»): one form, one temporary pass per car.
 * The API has no group pass, so the client orders passes one by one with the same window and comment.
 */
export const MAX_CREW_CARS = 10;

/** Plates as typed → normalized, without blanks and repeats (the server would refuse a duplicate anyway). */
export function crewPlates(typed: readonly string[]): string[] {
  return [...new Set(typed.map(normalizePlate).filter((p) => p.length >= 3))];
}

/** Names as typed → trimmed, single spaces, without blanks and repeats (one pass per person, #4216). */
export function crewNames(typed: readonly string[]): string[] {
  const seen = new Set<string>();
  const names: string[] = [];
  for (const raw of typed) {
    const name = raw.trim().replace(/\s+/g, ' ');
    if (name.length < 2 || seen.has(name.toLowerCase())) continue;
    seen.add(name.toLowerCase());
    names.push(name);
  }
  return names;
}

const CREW_PURPOSE = /строит|стройк|рабоч|ремонт|подряд|бригад/i;

/** The object's visit purpose that fits a construction crew, if it has one. */
export function crewPurpose<T extends { id: number; name: string }>(options: readonly T[]): T | null {
  return options.find((o) => CREW_PURPOSE.test(o.name)) ?? null;
}

/** Text for the foreman: plates (or names), period and address — enough to show at the checkpoint. */
export function crewShareMessage(input: { objectName: string; address: string; plates: readonly string[]; startsAt: Date; expiresAt: Date; walkers?: boolean }): string {
  const from = `${moscowShortDate(input.startsAt)} ${moscowTime(input.startsAt)}`;
  const to = `${moscowShortDate(input.expiresAt)} ${moscowTime(input.expiresAt)}`;
  if (input.walkers) return `Пропуск на проход в ${input.objectName}, ${input.address}: ${input.plates.join(', ')} — с ${from} по ${to}. Охрана пропустит по имени.`;
  return `Пропуск на въезд в ${input.objectName}, ${input.address}: ${input.plates.join(', ')} — с ${from} по ${to}. Охрана видит пропуск по номеру.`;
}

/** «Продлить на неделю»: a week past the later of the current last day and today ("Y-m-d"). */
export function extendedUntil(currentUntil: string, now: Date, days = 7): string {
  const today = startOfMoscowDay(now);
  const current = currentUntil ? startOfMoscowDay(parseServerDate(`${currentUntil} 12:00:00`)!) : today;
  const base = current > today ? current : today;
  return formatServerDate(startOfMoscowDay(base, days)).slice(0, 10);
}

/** 2 пропуска, 5 пропусков, 21 пропуск. */
export function passesWord(n: number): string {
  const d = n % 10;
  if (n % 100 >= 11 && n % 100 <= 14) return 'пропусков';
  return d === 1 ? 'пропуск' : d >= 2 && d <= 4 ? 'пропуска' : 'пропусков';
}
